/**
 *
 * @param {Object} state
 * @returns User
 */
export default (state) => state.user.data;
